import extractDataFromFirebaseCredential from 'lib/extractDataFromFirebaseCredential';

import { AuthUser } from 'types/User';
import { authAndSignInWithProvider, AuthProviders } from 'lib/Auth';

export default async function signInWithFacebook(): Promise<AuthUser> {
  const credential = await authAndSignInWithProvider(AuthProviders.Facebook);
  return extractDataFromFirebaseCredential(credential);
}
